import { useEffect } from "react";
import Header from "../../ui-components/Header";
import Footer from "../../ui-components/Footer";
import { Typography, Box } from "@mui/material";
import AOS from "aos";
import "../Users/Welcome/style.scss";
import "./Agreement.scss";
import "aos/dist/aos.css";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      mirror: true,
    });
  });
  return (
    <div className="welcome">
      <Header />

      <div className="container">
        <Box className="agreement">
          <Typography
            variant="h5"
            component="h1"
            gutterBottom
            data-aos="fade-up"
          >
            About Us
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            Welcome to Pellifix.com — where hearts find harmony and meaningful
            relationships begin.
            <br />
            At Pellifix, we believe that every love story deserves a strong
            foundation built on trust, values, and genuine connection. Founded
            with the vision of helping individuals and families find their
            perfect life partner, Pellifix is a trusted online matrimony
            platform that blends modern technology with traditional values.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            Our Purpose
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            In a world that moves fast, finding the right partner shouldn’t be
            left to chance. Pellifix exists to make the journey of finding a
            soulmate secure, respectful, and fulfilling. We provide a safe and
            supportive space where individuals from diverse backgrounds,
            cultures, and communities can connect with sincerity and confidence.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            Our Mission
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            To empower individuals to discover meaningful and lifelong
            relationships through:
            <br />
            Trusted connections with profiles that are authentic and verified.
            <br />
            Personalized matchmaking powered by intelligent tools and human
            insights.
            <br />
            Privacy and security that safeguard your personal information.
            <br />
            Inclusive community that embraces cultures, traditions, and modern
            aspirations.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            What Sets Us Apart
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            <Typography component="span" fontWeight={600}>
              💖 User-Centric Experience
            </Typography>
            <br />
            <Typography component={"span"}>
              From smooth registration to intuitive search features, Pellifix is
              designed for ease and clarity — helping you focus on what matters
              most.
            </Typography>
            <br />
            <Typography component="span" fontWeight={600}>
              🔍 Advanced Matching Tools
            </Typography>
            <br />
            <Typography component={"span"}>
              Our smart matchmaking system helps you discover compatible
              profiles based on values, preferences, and lifestyle.
            </Typography>{" "}
            <br />
            <Typography component="span" fontWeight={600}>
              🛡️ Safety First
            </Typography>
            <br />
            <Typography component={"span"}>
              Your privacy and trust are our top priorities. We use secure
              systems and verification processes to ensure authenticity.
            </Typography>{" "}
            <br />
            <Typography component="span" fontWeight={600}>
              👨‍👩‍👧 Family-Friendly Platform
            </Typography>
            <br />
            <Typography component={"span"}>
              We understand the role families play in matrimonial decisions.
              Pellifix welcomes families to participate and support their loved
              ones in the search for a perfect match.
            </Typography>
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            Our Values
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            Integrity – We maintain transparency and ethical standards in all we
            do.
            <br />
            Respect – Every individual on Pellifix is treated with dignity and
            care.
            <br />
            Empowerment – We support your journey toward making meaningful life
            decisions.
            <br />
            Innovation – Continuous improvement ensures a modern, reliable
            experience.
          </Typography>
          <Typography
            variant="subtitle2"
            component="p"
            data-aos="fade-up"
            fontWeight={500}
          >
            Your Journey Starts Here Whether you’re seeking a soulmate, a
            supportive partner, or a relationship grounded in mutual respect and
            love — Pellifix.com is your trusted companion in the beautiful
            journey of life. Join us today and let your love story begin.
          </Typography>
        </Box>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
